<template>
  <!-- 主页 -->
  <van-row>
    <div v-show="!isMobile" class="van-notify van-notify--warning">
      <i class="van-icon van-icon-bell mar-rgt-5"></i>
      <span>如需查看{{roomTitle}}日历，可调大窗口宽度后刷新页面</span>
    </div>

    <van-grid class="mar-all-10" :column-num="gridList.length">
      <van-grid-item v-for="ele in gridList" :key="ele.key" @click="switchPages(ele.key)"
                     :class="ele.textStyle || 'text-normal'">    <!-- 渲染日期grid -->
        <i :class="ele.icon" class="van-grid-item__icon"></i>
        <span class="van-grid-item__text text-md text-bold">{{ele.title}}</span>
      </van-grid-item>
    </van-grid>

    <div class="bg-white mar-hor-10 mar-btm mt-schedule-wrap">
      <div>
        <p class="pad-top pad-hor flex-wrap-between">
          <span class="text-hv text-lg">{{calendarTitles.title}}</span>
          <!--<a class="text-primary" @click="handleWeek">{{calendarTitles.weekAct}}</a>-->
          <a class="text-primary text-bold" @click="switchPages('schedule')">我的日程 ></a>
        </p>
        <!--<van-calendar :poppable="false" class="pad-hor-5"
                      :show-confirm="false" @confirm="getMeetings"
                      :min-date="calendarRange.min" :max-date="calendarRange.max"></van-calendar>-->
        <div class="mt-schedule pad-hor-5 van-calendar">
          <div class="van-calendar__header">
            <div class="van-calendar__weekdays">
              <span class="van-calendar__weekday">日</span>
              <span class="van-calendar__weekday">一</span>
              <span class="van-calendar__weekday">二</span>
              <span class="van-calendar__weekday">三</span>
              <span class="van-calendar__weekday">四</span>
              <span class="van-calendar__weekday">五</span>
              <span class="van-calendar__weekday">六</span>
            </div>
          </div>
          <div class="van-calendar__body">
            <div class="van-calendar__month">
              <div role="grid" class="van-calendar__days">
                <div class="van-calendar__day" v-for="(date, idx) in calendarDayOptions"
                     :class="date.isToday?'today':''"
                     :key="idx" @click="selectedDayIdx=idx">
                  <div :class="idx===selectedDayIdx ?'van-calendar__selected-day':''">
                    {{date.isToday ? '今天' : date.value}}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <van-divider class="mar-top-5 mar-btm-0"></van-divider>

        <div class="mt-schedule-ctn" :class="meetingData.length ? '' : 'flex-center'">
          <div v-if="loading" class="text-center">
            <van-loading size="24px" vertical color="#2D69E0">加载中...</van-loading>
          </div>
          <div v-else-if="!meetingData.length">
            <empty-notice :image="'meeting'" :desc="'暂无会议~'"></empty-notice>
            <div v-show="showReserveBtn" class="text-center mar-top">
              <van-button type="primary" plain size="small"
                          @click="switchPages(listInfo.reserve.key, true)">新建预约
              </van-button>
            </div>
          </div>
          <div v-else>
            <meeting-list-cell v-for="(ele, idx) in meetingList" :key="idx"
                               :formatted-mt="ele" :is-time-mode="true" :btm-class="'list-cell-title'"
                               @click-cell="handleDetail(ele)">
            </meeting-list-cell>
          </div>
        </div>
      </div>

      <permit-container :permit-key="permitsMap.meetingSubs">
        <div class="bord-top">
          <calendar-subs :is-self="true"></calendar-subs>
        </div>
      </permit-container>
    </div>
    <div class="pad-btm-10">
      <div class="text-sm text-center">版本号：{{cmsVer}}</div>
    </div>

    <!--<van-col span="24" v-for="k in Object.keys(listInfo)" :key="k">
      <div class="bg-white mar-hor mar-top-20 pad-ver text-center" @click="switchPages(k)">
        <h3 class="text-hv">{{listInfo[k].title}}</h3>
        <p class="text-lt">{{listInfo[k].subTitle}}</p>
      </div>
      <permit-container :permit-key="permitsMap.meetingSubs">
        <div v-show="k==='meeting'" class="bord-top mar-hor">
          <calendar-subs :is-self="true"></calendar-subs>
        </div>
      </permit-container>
    </van-col>

    <permit-container :permit-key="permitsMap.userPanel" class="personal-center">
      <van-button round icon="manager" @click="toUserPanel"></van-button>
    </permit-container>-->

    <back-route-hdr :back-mode="'func'" @handle-back="closePage()"></back-route-hdr>
  </van-row>
</template>

<script>
  import routerMeta from "../router/routerMeta";
  import {
    checkIsMobile, checkIsWeChat, checkIsWXWork,
    checkShowPermit,
    formatMListDoc, initWeiTalkJsBridge,
    setSchReserveDate,
    sortMeeting,
    removePagePosition
  } from "../../../tools/utils";
  import {commonConfig, momentFormat} from "../../../config/common";
  import {clearStorage, getStorage, StorageKey} from "../../../tools/storage";
  import CalendarSubs from "../components/CalendarSubs"
  import {meeting} from "../../../server";
  import MeetingListCell from "../components/MeetingListCell"

  export default {
    components: {
      MeetingListCell,
      CalendarSubs
    },
    data() {
      return {
        isMobile: checkIsMobile(),
        listInfo: {
          reserve: {
            key: "reserve",
            title: "预约会议",
            // subTitle: "RESERVE A MEETING",
            textStyle: "text-primary",
            icon: "iconfont icon-zengjia"
          },
          meeting: {
            key: "meeting",
            title: "会议列表",
            // subTitle: "MY MEETING LIST",
            icon: "iconfont icon-richeng"
          },
        },
        roomPanel: {
          key: "room",
          // title: "会议室",
          // subTitle: "CONFERENCE ROOM",
          icon: "iconfont icon-meetingroom"
        },
        userPanel: {
          key: "userPanel",
          title: "个人中心",
          icon: "iconfont icon-yonghu"
        },
        thisDate: moment().startOf('day').toDate(),
        todayVal: moment().format('D'),
        meetingData: [],
        loading: true,
        selectedDayIdx: (new Date()).getDay(),
        nextWeek: false,
      }
    },
    computed: {
      roomTitle() {
        return this.$store.state.formTitles.meetingRoom
      },
      gridList() {
        const permissionList = this.$store.state.permissionList || [];
        const arr = Object.values(this.listInfo);
        if (checkShowPermit(permissionList, this.permitsMap.roomList)) {
          arr.splice(1, 0, {
            ...this.roomPanel,
            title: this.roomTitle
          })
        }
        if (checkShowPermit(permissionList, this.permitsMap.userPanel)) {
          arr.push(this.userPanel)
        }
        return arr
      },
      // 处理会议列表数据
      meetingList() {
        const list = this.meetingData.map(ele => formatMListDoc(ele, this, this.selectedDate));
        return list.sort(sortMeeting)
      },
      /*
      calendarRange() {
        const range = {};
        const weekDay = this.thisDate.getDay();
        range.min = moment(this.thisDate).subtract(weekDay, 'day').toDate();
        range.max = moment(this.thisDate).add(6 - weekDay, 'day').toDate();
        return range
      },
      */
      firstDate() {
        const weekDay = this.thisDate.getDay();
        if (this.nextWeek) {
          return moment(this.thisDate).add(6 - weekDay + 1, 'day').toDate();
        }
        return moment(this.thisDate).subtract(weekDay, 'day').toDate();
      },
      calendarDayOptions() {
        const options = [];
        let dayIdx = 0;
        while (dayIdx < 7) {
          const date = moment(this.firstDate).add(dayIdx, 'day').format('D');
          options.push({value: date, isToday: this.todayVal === date});
          dayIdx++
        }
        return options
      },
      // 日历标题渲染
      calendarTitles() {
        return {
          title: this.nextWeek ? "下周会议" : "本周会议",
          weekAct: this.nextWeek ? "< 本周" : "下周 >"
        }
      },
      // 时间选取
      selectedDate() {
        return moment(this.firstDate).add(this.selectedDayIdx, 'day').toDate()
      },
      showReserveBtn() {
        const diff = moment(this.selectedDate).diff(moment(this.thisDate), 'day');
        // console.log(diff);
        return diff >= 0
      },
      cmsVer() {
        return this.$store.state.sysConfig.cmsVer;
      }
    },
    watch: {
      // 选取时间后渲染会议列表
      selectedDate(val) {
        // console.log(moment(val).format('YYYY-MM-DD'));
        this.getMeetings(val)
      },
    },
    created() {
      removePagePosition()
      if (getStorage(StorageKey.token)) {
        this.initPage();
      }
      // Android 端需提前 init
      if (getStorage(StorageKey.mobJsBridge) === commonConfig.weichai) {
        initWeiTalkJsBridge(function () {
          console.log("initJsBridge.");
        })
      }
    },
    mounted() {
      this.setPageHeight();
    },
    destroyed() {
      document.querySelector('html').removeAttribute('style');
      document.querySelector('body').removeAttribute('style');
      document.querySelector('#app').removeAttribute('style');
    },
    methods: {
      switchPages(key, pm) {
        switch (key) {
          case this.listInfo.reserve.key:
            pm && setSchReserveDate.call(this, this.selectedDate);
            this.$router.push({name: routerMeta.meetingReserveFromHome.name});
            break;
          case this.listInfo.meeting.key:
            this.$router.push({name: routerMeta.meetingList.name});
            break;
          case this.roomPanel.key:
            this.$router.push({name: routerMeta.roomList.name});
            break;
          case this.userPanel.key:
            this.$router.push({name: routerMeta.userPanel.name});
            break;
          case "schedule":
            this.$store.commit('setSchFilter', {
              selectedDayVal: moment(this.selectedDate).format(momentFormat.dateFormatDaySlant)
            });
            this.$router.push({name: routerMeta.meetingSchedule.name});
            break;
          default:
        }
      },
      initPage() {
        const pathRecord = getStorage(StorageKey.pathRecord);
        if (pathRecord) {
          this.$router.push({path: pathRecord});
          clearStorage(StorageKey.pathRecord)
        }
        this.getMeetings()
      },
      // 获取会议信息
      getMeetings(date) {
        this.loading = true;
        const userId = getStorage(StorageKey.userId);
        const filter = {
          createdBy: userId,
          userId: userId,
          ccUserId: userId,
          getIsUserCheckin: true,
          date: (date || this.thisDate).valueOf()
        };
        meeting.queryList(this, {queryFilter: filter}).then(({searchMeeting: data = {}}) => {
          this.loading = false;
          this.meetingData = (data.meetingEdges || []);
        }).catch(err => {
          this.loading = false;
          // console.log(err);
          vtToast(err.message)
        })
      },
      handleWeek() {
        this.nextWeek = !this.nextWeek;
        if (this.nextWeek) {
          this.selectedDayIdx = 1;  // 周一
        } else {
          this.selectedDayIdx = this.thisDate.getDay()
        }
      },
      handleDetail(doc) {
        this.$router.push({name: routerMeta.meetingDetailFromHome.name, params: {mid: doc.mid}})
      },
      closePage() {
        try {
          // 企业微信、微信
          if ((checkIsWXWork() || checkIsWeChat()) && WeixinJSBridge) {
            WeixinJSBridge.call('closeWindow');
            return;
          }
          // WeiTalk
          if (getStorage(StorageKey.mobJsBridge) === commonConfig.weichai) {
            initWeiTalkJsBridge(function () {
              if (window.WebViewJavascriptBridge) {
                window.WebViewJavascriptBridge.callHandler('closePage', {
                  "apptag": "ezLink"
                })
              } else {
                vtToast("initJsBridge failed.");
              }
            });
            return;
          }
        } catch (e) {
          vtToast(e.message);
        }
        if (this.$route.name === routerMeta.home.name) {
          window.location.replace(window.location.origin + window.location.pathname + '/home');
        } else {
          window.history.go(-1)
        }
      },
      setPageHeight() {
        document.querySelector('html').style.height = '100%';
        document.querySelector('body').style.height = 'calc(100% - 10px)';
        document.querySelector('#app').style.height = '100%';
      },
    },
  }
</script>

<style lang="less">
  .van-row {
    height: 100%;
  }

  .mt-schedule-wrap {
    min-height: calc(100% - 140px);
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }

  .personal-center {
    position: fixed;
    bottom: 50px;
    right: 15px;
  }

  .van-grid-item__text {
    color: unset !important;
  }

  .van-grid-item__icon {
    font-size: 28px !important;
  }
</style>

<style lang="less" scoped>
  .van-calendar {
    height: auto !important;
  }

  @media only screen and (max-height: 670px) {
    .mt-schedule-ctn {
      min-height: 300px;
    }
  }

  @media only screen and (device-width: 320px) and (device-height: 568px) {
    .mt-schedule-ctn {
      min-height: 200px;
    }

    .van-empty {
      height: 167px;

      /deep/ .van-empty__image {
        width: 110px;
        height: 110px;
      }
    }
  }
</style>
